import { useEffect } from 'react';
import { Link, Route } from 'react-router-dom';

import { InvoiceService } from '../service/InvoiceService';

import { TraCuu } from './tra-cuu';

const invoiceService = new InvoiceService();

export const App = () => {

	useEffect(() => {
		invoiceService.getIntroduction().then(data => {
			if (data?.description?.trim()) {
				// setDisplayAds(data.description);
			}
		}).catch(() => {
		});
	}, []);

	return (
		<div className="App">
			<header className="layout-topbar">
				<div className="topbar-container">
					<Link to="/" className="layout-topbar-logo">
						<img src={'/assets/iam-invoice/iam-invoice.png'} alt="IAM Invoice" />
					</Link>
					<ul className="iam-topbar-actions">
						<li className="iam-topbar-action">
							<a href="https://zalo.me/3919081551375297120" rel="noreferrer" target="_blank" title="Hỗ trợ trực tiếp">
								<img src="/assets/images/zalo-60x60.png" alt="Zalo" width="30" />
								<span>Hỗ trợ trực tiếp</span>
							</a>
						</li>
					</ul>
				</div>
			</header>

			<Route path="/" exact component={TraCuu} />

			<footer className="layout-footer">
				<div className="footer-container">
					<div className="footer-column footer-brand">
						<h2>I.A.M INVOICE</h2>
						<p>IAM Invoice là giải pháp hóa đơn điện tử toàn diện, được tin dùng bởi hàng nghìn doanh nghiệp và hộ kinh doanh trên toàn quốc.</p>
					</div>
					<div className="footer-column footer-company">
						<h3>CÔNG TY CỔ PHẦN PHẦN MỀM IAM VIỆT NAM</h3>
						<p><i className="pi pi-map-marker" />Trụ sở chính: CTT11 Kiến Hưng Luxury, Phường Kiến Hưng, Thành phố Hà Nội</p>
						<p><i className="pi pi-phone" />Hotline: 0968 194 976 <span>|</span> Email: contact@iamsoftware.com.vn <span>|</span> Website: iamsoftware.com.vn</p>
					</div>
					<div className="footer-column footer-social">
						<h3>Kết nối với chúng tôi</h3>
						<div className="social-links">
							<a href="https://www.facebook.com/IAM.SW.VIETNAM?locale=vi_VN" target="_blank" rel="noreferrer" aria-label="Facebook"><img src="/assets/images/facebook.webp" alt="Facebook" style={{ width: '46px', height: '46px', maxWidth: 'none' }} /></a>
							<a href="https://www.youtube.com/@IAMSoftwareVietNam" target="_blank" rel="noreferrer" aria-label="YouTube"><img src="/assets/images/YouTube.webp" alt="YouTube" style={{ width: '32px', height: '32px', maxWidth: 'none' }} /></a>
							<a href="https://zalo.me/3919081551375297120" target="_blank" rel="noreferrer" aria-label="Zalo"><img src="/assets/images/zalo-60x60.png" alt="Zalo" /></a>
						</div>
					</div>
				</div>
				<div className="footer-copyright">© 2026 IAM Software. All rights reserved.</div>
			</footer>
		</div>
	);
}
